import type { PropType } from "vue";

export const TutorialPropsOption = {
    mode: { type: String as PropType<"gene" | "disease" | "model">, required: true },
} as const;

export type TutorialProps = ExtractPropTypes<typeof TutorialPropsOption>;
